import { ErrorBoundary as ReactErrorBoundary } from "react-error-boundary";
import type { ReactNode } from "react";
import styles from "./CardErrorBoundary.module.css";

interface FallbackProps {
  error: Error;
  resetErrorBoundary: () => void;
}

function CardErrorFallback({ error: _error, resetErrorBoundary }: FallbackProps) {
  return (
    <div className={styles.fallback} role="alert">
      <p className={styles.message}>
        This section failed to load.
      </p>
      <button
        type="button"
        className={styles.retryBtn}
        onClick={resetErrorBoundary}
      >
        Retry
      </button>
    </div>
  );
}

interface CardErrorBoundaryProps {
  children: ReactNode;
}

export function CardErrorBoundary({ children }: CardErrorBoundaryProps) {
  return (
    <ReactErrorBoundary
      FallbackComponent={CardErrorFallback}
      onError={(error) =>
        console.error("[Analytics] Card error:", error)
      }
    >
      {children}
    </ReactErrorBoundary>
  );
}
